import React from 'react';
import { StaticPage, TopbarContainer } from '..';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  NamedLink,
} from '../../components';
import { FormattedMessage } from '../../util/reactIntl';

import css from './ExplainCancellationPage.module.css';
import image from '../../assets/trailer-with-sticker.avif';

const ExplainCancellationPage = () => {
  return (
    <StaticPage
      title="Cancellation of hire explained"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'ExplainCancellationPage',
        description: 'Cancellation of hire explained',
        name: 'Cancellation of hire explained',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.staticPageWrapper}>
          <div className={css.contentWrapper}>
            <div className={css.imageContainer}>
              <img src={image} alt="trailer" className={css.croppedImage} />
            </div>
            <div className={css.contentMain}>
              <h1 className={css.helpTitle}>Cancellations and refunds</h1>
              <p>
                You can cancel a booking or booking request whenever you need to. Refund eligibility
                and processing depends on when you cancel.
              </p>

              <ul className={css.cancellationList}>
                <li>
                  <span className={css.bold}>
                    Booking requests (unconfirmed bookings) are reversible
                  </span>
                  <br />
                  If you cancel a booking request (before the trailer owner has confirmed it), the
                  temporary hold ("pending" transaction) on your card will be cancelled immediately.
                  It might still appear as "pending" in your online banking or your banking app
                  until your bank processes the cancellation, which usually happens within a few
                  minutes or hours. Once the bank processes the cancellation, the transaction will
                  disappear from your online banking completely.
                </li>
                <li>
                  <span className={css.bold}>
                    Confirmed bookings cancelled more than 24 hours before the scheduled pick-up
                    time are refunded
                  </span>
                  <br />
                  If your booking is confirmed by the trailer owner and you cancel more than 24
                  hours before the scheduled pick-up time, you'll receive a full refund. We issue
                  the refund as soon as you cancel the booking. It may take several days to arrive
                  in your bank or card account, depending on your bank's processing times.
                </li>
                <li>
                  <span className={css.bold}>
                    Confirmed bookings that are cancelled less than 24 hours before the scheduled
                    pick-up time are not refunded
                  </span>
                  <br />
                  If you cancel a confirmed booking less than 24 hours before the scheduled pick-up
                  time, then as per the{' '}
                  <NamedLink name="RentalTermsPage">
                    <FormattedMessage id="Footer.rentalTerms" />
                  </NamedLink>
                  , no refund will be provided.
                </li>
              </ul>
              <div>
                <h2>How to cancel your booking</h2>
                <p>
                  It's easy to cancel your booking on Local Trailer Hire. Just follow these steps:
                </p>
                <ol>
                  <li>
                    <span className={css.bold}>Log in</span>
                    <p>Log in to your account on the website.</p>
                  </li>
                  <li>
                    <span className={css.bold}>Access "My bookings"</span>
                    <p>
                      Go to "My bookings." If you're using a mobile device, you can find the "My
                      bookings" link via the burger menu in the top left corner after logging in. If
                      you're on a computer, you can find the link at the top right of your screen.
                    </p>
                  </li>
                  <li>
                    <span className={css.bold}>Select your booking</span>
                    <p>Once you're on the bookings page, choose the booking you want to cancel.</p>
                  </li>
                  <li>
                    <span className={css.bold}>Cancel</span>
                    <p>
                      Press the "Cancel booking" or "Cancel booking request" button on the booking
                      page.
                    </p>
                  </li>
                </ol>
                <p>
                  Please remember that you can cancel at any time, but your refund depends on when
                  you cancel.
                </p>
              </div>
            </div>
            <NamedLink name="HelpPage" className={css.link}>
              <h3 className={css.heading}>
                {'<'} <FormattedMessage id="Footer.toHelpPage" />
              </h3>
            </NamedLink>
          </div>
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

export default ExplainCancellationPage;
